import classNames from 'classnames';

import { SectionTitle, TextBlock } from '@/ui/index';

import styles from './ServicesOperations.module.scss';

const ServicesOperations = ({ data, className }) => {
  const renderOperationsItem = (item, index) => {
    return (
      <li
        className={styles.operations__element}
        key={index}
        itemScope
        itemType='https://schema.org/ListItem'
      >
        {item?.text}
      </li>
    );
  };

  return (
    <section
      className={classNames(styles.operations, className)}
      itemScope
      itemType='https://schema.org/Service'
    >
      {data?.text && (
        <TextBlock className={classNames(styles.operations__top_text)} isHtml>
          {data.text}
        </TextBlock>
      )}
      {data?.title && (
        <SectionTitle className={styles.operations__title} isHtml>
          {data.title}
        </SectionTitle>
      )}
      {data?.description && (
        <TextBlock
          className={classNames(styles.operations__text, 'text--large')}
          isHtml
        >
          {data.description}
        </TextBlock>
      )}
      {data?.operations && (
        <ul className={styles.operations__list}>
          {data?.operations?.map(renderOperationsItem)}
        </ul>
      )}
    </section>
  );
};

export default ServicesOperations;
